import React, {Component} from 'react';
import { Sigma, SigmaEnableWebGL , RandomizeNodePositions, RelativeSize, LoadJSON, ForceAtlas2, EdgeShapes } from 'react-sigma';
import ForceLink from 'react-sigma/lib/ForceLink'
import "../Sigma.css";

import { Form, Button, Input, Icon, Grid, Segment } from 'semantic-ui-react'

class SigmaVis extends Component {

  render() {
    const { graphPath, onClickNode } = this.props

    return (
          <Sigma renderer="canvas" onClickNode={onClickNode} onOverNode={e => console.log("Mouse over node: " + e.data.node.label)}
            style={{maxWidth:"inherit", height:"70vh"}} settings={{clone: false, animationsTime: 5000, defaultNodeColor: "#3388AA", minArrowSize:5, drawEdgeLabels: true, drawEdges:true}}>
            <LoadJSON path={graphPath}>
              <RandomizeNodePositions />
              <EdgeShapes default="curvedArrow"/>
              <ForceLink
                randomize="locally"
                barnesHutOptimize={false}
                barnesHutTheta={0.5}
                background
                easing="cubicInOut"
                gravity={1}
                edgeWeightInfluence={0}
                alignNodeSiblings={false}
                timeout={1000}
                outboundAttractionDistribution={false}
              />
              <RelativeSize initialSize={15} />
            </LoadJSON>

          </Sigma>
        )
      }
    }

    export default SigmaVis;
